import { useMatches } from "@remix-run/react"
import type { User } from "~/types"

export function useUser(): User {
    const matches = useMatches()
    const root = matches.find(match => match.id === 'root')
    const rootGeneric = matches.find(match =>  match.id ==='routes/auth/login-spid/index')
    return root?.data?.user || rootGeneric?.data?.user
}